<template>
    <div>
        <div class="display-1 pt-4">{{ $t("title.status_history") }}</div>
        <v-timeline align-top dense v-if="trapStatus.docs" :key="page">
            <v-timeline-item
                :color="
                    !status.right && !status.left
                        ? 'red'
                        : !status.right || !status.left
                        ? 'orange'
                        : 'green'
                "
                small
                v-for="status in trapStatus.docs"
                :key="status._id"
            >
                <v-layout>
                    <v-flex xs4>
                        <strong>
                            {{
                                status.timeStamp
                                    | dateFormat(
                                        {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                        },
                                        fullLocale
                                    )
                            }}
                        </strong>
                    </v-flex>
                    <v-flex xs6>
                        <strong>{{ $t(`status.action.${status.action || "unknown"}`) }}</strong>
                        &nbsp;
                        <v-icon small color="primary" v-if="status.notified">message</v-icon>
                        <div class="caption">
                            <v-icon small>battery_full</v-icon>
                            {{ status.battery }}% |
                            <v-icon small>signal_cellular_alt</v-icon>
                            {{ status.signal }}%
                        </div>
                    </v-flex>
                    <v-flex xs1>
                        <v-btn @click="confirmRemove = status._id" small icon>
                            <v-icon small color="red">delete</v-icon></v-btn
                        ></v-flex
                    >
                </v-layout>
            </v-timeline-item>
        </v-timeline>
        <v-layout justify-center v-if="!trapStatus.docs">
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </v-layout>
        <BasePagination
            v-if="trapStatus && trapStatus.pages"
            :page="page"
            :pages="trapStatus.pages"
            @next="nextPage"
            @previous="previousPage"
            :total="trapStatus.total"
            :loading="$apollo.queries.trapStatus.loading"
        />

        <v-dialog :value="confirmRemove" max-width="290">
            <v-card>
                <v-card-title class="headline"></v-card-title>
                <v-card-text></v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :loading="loading"
                        @click="confirmRemove = false"
                        v-t="'button.cancel'"
                    ></v-btn>
                    <v-btn
                        color="error"
                        :loading="loading"
                        @click="deleteOne(confirmRemove)"
                        v-t="'button.confirm_delete'"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapGetters } from "vuex"
export default {
    data() {
        return {
            page: 1,
            loading: false,
            trapStatus: {},
            confirmRemove: false,
        }
    },
    methods: {
        previousPage() {
            if (!this.$apollo.queries.trapStatus.loading && this.page > 1) {
                this.page = this.page - 1
            }
        },
        nextPage() {
            if (!this.$apollo.queries.trapStatus.loading && this.page < this.trapStatus.pages) {
                this.page = this.page + 1
            }
        },
        async deleteOne(id) {
            this.loading = true

            try {
                const result = await this.$apollo.mutate({
                    mutation: require("@/graphql/trapStatus/removeTrapStatus.gql"),
                    variables: {
                        _id: id,
                    },
                })

                if (result) {
                    this.trapStatus.docs.splice(
                        this.trapStatus.docs.findIndex(d => d._id == id),
                        1
                    )
                    this.$notify({
                        title: this.$i18n.t("notify.removed"),
                        type: "success",
                        timeout: 2000,
                    })
                }
            } catch (e) {}
            this.loading = false
            this.confirmRemove = false
        },
    },
    computed: {
        ...mapGetters({ fullLocale: "user/fullLocale" }),
    },
    props: {
        trap: { type: String, required: true },
    },
    apollo: {
        trapStatus: {
            query: require("@/graphql/trapStatus/trapStatus.gql"),
            variables() {
                return {
                    trap: this.trap,
                    page: this.page,
                }
            },
        },
    },
}
</script>
